<rappider-title-toolbar [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton"></rappider-title-toolbar>

<rappider-workflow-step-function-form [formLayout]="createFormConfig.formLayout"
                                      [isSubmitButtonFloat]="createFormConfig.isSubmitButtonFloat"
                                      (workflowStepFunctionFormSubmit)="onCreateWorkflowStepFunction($event)"></rappider-workflow-step-function-form>
